import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Datenschutz from '@/views/Datenschutz'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/datenschutz',
      name: 'Datenschutz',
      component: Datenschutz
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js